/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['ordered', 'check', 'minus', 'unordered', 'black', 'blue'] }] */
import classNames from 'classnames';

import Typography from '@components/atoms/Typography';
import createStyleVariables from 'utils/createStyleVariables';

import { ItemProps } from '../../CheckList.types';
import classes from './CheckListItem.module.scss';

const sizeMap = {
  sm: {
    width: {
      check: 11,
      minus: 24,
    },
    height: {
      check: 6,
      minus: 10,
    },
  },
  md: {
    width: {
      check: 15,
      minus: 24,
    },
    height: {
      check: 8,
      minus: 10,
    },
  },
};

const getSize = (
  dimension: 'width' | 'height',
  size: Required<ItemProps>['checkerSize'],
  variant: Required<ItemProps>['variant']
): string => `${sizeMap[size][dimension][variant]}px`;

const CheckListItem = ({
  children,
  classes: customClasses,
  checkerSize = 'md',
  variant = 'check',
  color = 'black',
  size = 'body1',
  listStyle = 'unordered',
}: ItemProps): JSX.Element => (
  <li
    className={classNames(classes.wrapper, customClasses?.root, classes[variant], classes[listStyle], classes[color])}
  >
    {listStyle === 'unordered' && (
      <span
        style={createStyleVariables({
          iconWidth: getSize('width', checkerSize, variant),
          iconHeight: getSize('height', checkerSize, variant),
        })}
        className={classes.checker}
      />
    )}
    <Typography variant={size} weight="400" renderAs="div" className={classNames(customClasses?.text, classes.text)}>
      {children}
    </Typography>
  </li>
);

export default CheckListItem;
